import { render } from "./InfoTab.vue?vue&type=template&id=510c6ea1"
import script from "./InfoTab.vue?vue&type=script&lang=ts"
export * from "./InfoTab.vue?vue&type=script&lang=ts"
script.render = render

export default script